import init from './init';
import state from './state';

export default {
  ...init,
  ...state,
};
